import { css } from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
export const focusRing = css(["outline-offset:1px;outline:2px solid ", ";"], CALYPSO);